import SiteMailoutCreate from "./SiteMailoutCreate"
import SiteMailoutEdit from "./SiteMailoutEdit"
import SiteMailoutList from "./SiteMailoutList"
import SiteMailoutShow from "./SiteMailoutShow"

const SiteMailoutCRUD = {
  create: SiteMailoutCreate,
  edit: SiteMailoutEdit,
  list: SiteMailoutList,
  show: SiteMailoutShow,
}

export default SiteMailoutCRUD
